import { PropsWithChildren } from "react"

export default function UserExperienceLayout({ children }: PropsWithChildren) {
  return (
    <div className="mx-auto my-4 max-w-2xl border-2 border-cerulean-100 ">
      {children}
    </div>
  )
}
